module.exports = __webpack_public_path__ + "img/14.e0399746.jpg";